module.exports = __webpack_public_path__ + "files/858b5f4f68070bfa2064d5647ba79c13.png";